import { getStorageItem } from '@parrot-software/utils';

type CurrentOrganization = {
  uuid: string;
  name?: string;
};

const USER_ORGANIZATION_STORAGE_KEY = 'parr-organization';

export const getCurrentOrganization = (): CurrentOrganization | null => {
  const result = getStorageItem<CurrentOrganization>(USER_ORGANIZATION_STORAGE_KEY, {} as CurrentOrganization);
  return result.success ? result.data ?? null : null;
};

export const getCurrentOrganizationUudi = (): string => getCurrentOrganization()?.uuid ?? '';
